import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { Permission, SellerUserClient } from 'src/WebApiController';

import { useUserHasAnyOfPermissions } from './useUserHasAnyOfPermissions';

export const HAS_RELEASE_NOTES_UNREAD_QUERY_KEY =
  'SellerUserClient.getHasReleaseNotesUnread';

export const useHasReleaseNotesUnread = ({
  disabled,
}: {
  disabled?: boolean;
}) => {
  const { trackError } = useClientLogContext();
  const { activeAccountWebClientConfig } = useAppContext();

  const canViewReleaseNotes = useUserHasAnyOfPermissions(
    Permission.General_ViewReleaseNotes
  );
  const shouldQuery =
    activeAccountWebClientConfig.activeAccountId != null &&
    !disabled &&
    canViewReleaseNotes;

  const hasReleaseNotesUnreadQuery = useQuery({
    queryKey: [
      HAS_RELEASE_NOTES_UNREAD_QUERY_KEY,
      activeAccountWebClientConfig.activeAccountId,
      shouldQuery,
    ],
    queryFn: () => {
      if (!shouldQuery) {
        return null;
      }
      return new SellerUserClient(
        activeAccountWebClientConfig
      ).getHasReleaseNotesUnread(true);
    },

    enabled: shouldQuery,
    staleTime: Infinity, // seldom change data and we invalidate on reload
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('SellerUserClient.getHasReleaseNotesUnread', error);
      },
    },
  });

  return {
    hasReleaseNotesUnread: hasReleaseNotesUnreadQuery.data ?? false,
  };
};
